import { Role } from '../../../lib';

export interface User {
    id: string;
    email: string;
    fullName: string;
}

export type Permission =
    | 'createData'
    | 'editData'
    | 'deleteData'
    | 'readData'
    | 'createMetadata'
    | 'editMetadata'
    | 'deleteMetadata'
    | 'readMetadata';

export interface UserRoles {
    readOnly: Role;
    user: Role;
    admin: Role;
    governance: Role;
}
export const ROLES: UserRoles = {
    readOnly: 'sdzReadOnly',
    user: 'sdzUser',
    admin: 'sdzAdmin',
    governance: 'sdzGovernance',
};

export interface UserPermissions {
    createData: Permission;
    editData: Permission;
    deleteData: Permission;
    readData: Permission;
    createMetadata: Permission;
    editMetadata: Permission;
    deleteMetadata: Permission;
    readMetadata: Permission;
}

export const PERMISSIONS: UserPermissions = {
    createData: 'createData',
    editData: 'editData',
    deleteData: 'deleteData',
    readData: 'readData',
    createMetadata: 'createMetadata',
    editMetadata: 'editMetadata',
    deleteMetadata: 'deleteMetadata',
    readMetadata: 'readMetadata',
};

export interface RolePermissions {
    [key: string]: string[];
}

export const ROLE_PERMISSIONS: RolePermissions = {
    [ROLES.readOnly]: [PERMISSIONS.readData, PERMISSIONS.readMetadata],
    [ROLES.user]: [
        PERMISSIONS.readData,
        PERMISSIONS.createData,
        PERMISSIONS.editData,
        PERMISSIONS.deleteData,
        PERMISSIONS.readMetadata,
    ],
    [ROLES.admin]: [
        PERMISSIONS.readMetadata,
        PERMISSIONS.createMetadata,
        PERMISSIONS.editMetadata,
        PERMISSIONS.deleteMetadata,
    ],
    [ROLES.governance]: [
        PERMISSIONS.readMetadata,
        PERMISSIONS.createMetadata,
        PERMISSIONS.editMetadata,
        PERMISSIONS.deleteMetadata,
    ],
};
